<ion-content id="main-content" class="full-width-page">
    <div class="bg-theme-alt">
        <div class="bg-grad-special">
            <div class="bg-grad-special-alt">
                <div class="nk-ovm shape-u shape-contain shape-left-top"></div>
                <app-header></app-header>
                <section class="section bg-theme tc-light animated fadeInUp" data-animate="fadeInUp" data-delay="0.4"
                    style="visibility: visible; animation-delay: 0.4s;">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/ecosystem.png" alt="ecosystem">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Creating Anonymous, Secure, and
                                            Actionable Intelligence Through Tokenized Data</h6>
                                        <p>
                                            Our token tech removes identity and payment details from the data our users
                                            create on our marketplace and communication platform making the resulting
                                            data practically useless for research and analytic purposes. Collecting
                                            detailed marketing information upon enrollment and using our token tech to
                                            link everyone's anonymized marketing, transaction, and communication
                                            information creates a secure, comprehensive marketplace scale research
                                            resource. The fact that this research resource is anonymous together with
                                            the permissions of our user agreement gives government access to conduct
                                            research without violating any privacy regulations, making unprecedented
                                            actionable intelligence capabilities possible for government research and
                                            investigations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Securing Critical Infrastructure
                                            Through Tokenization and Reciprocal Authentication</h6>
                                        <p>
                                            Reciprocal authentication proves who the sender is to our network and then
                                            our network to that sender allowing our network to act as the monkey in the
                                            middle between any senders and recipients authenticating all parties before
                                            initiating access or the exchange of data or instructions. Knowing who you
                                            are dealing with and authenticating both the source and destination of data
                                            and instructions is essential for securing remote access to and control of
                                            our nation’s critical infrastructure, drones, IOT devices, unmanned
                                            vehicles, and spacecraft. Our adversaries need to be right only once to
                                            inflict serious damage, and we must be right 100% of the time. When the
                                            encryption protecting us now fails every remote access and control point
                                            where it is deployed will become vulnerable.
                                            Tokenization and reciprocal authentication combine to give us the best
                                            chances of creating and maintaining a defense 100% of the time and auto
                                            generative symmetric encryption at 256 characters will help in the short
                                            run.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/services.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/secured-transaction.png"
                                        alt="Secured Transaction">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Establishing an All-Government
                                            Secure Network for Unified Intelligence and Communication</h6>
                                        <p>
                                            Our network acts as the monkey in the middle between the interactions of our
                                            participants. When the participants are any combination of individuals and
                                            business entities, think of that network as the private sector monkey in the
                                            middle. We need to establish a distinct all-government monkey in the middle
                                            network to provide a separate secure link to pass individual and business
                                            interactions to all government divisions. In any large organization where we
                                            have siloed stores of data locked away in emails, texts, snail mail, written
                                            notes, voice mails, various social media networks, deposited between
                                            accounting, sales, and service departments with no way to share any of this
                                            information securely or otherwise the old saying that the left hand does not
                                            know what the right hand is doing is often very true and dangerous. This
                                            flaw in our national defense was one of the major takeaways from the 911
                                            Commission. The all-government monkey in the middle spanning every division
                                            from the white house down to the local dog catcher’s office makes it
                                            possible for every right hand to securely know what every left hand needs to
                                            know in near real time to make actionable intelligence capabilities possible
                                            without violating anyone’s privacy rights or exposing any government
                                            secrets.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Automating the Flow of Actionable
                                            Intelligence Through Government-Guided Data Triggers</h6>
                                        <p>
                                            Our platform is gathering the raw data required. We just need to know what
                                            data to send, who to send it to, and what triggers us to determine when to
                                            send it to automate the collection and delivery of actionable intelligence.
                                            Only the government representatives responsible for processing this kind of
                                            raw data into actionable intelligence and then acting upon it can provide
                                            these answers. Tell us what you want, what triggers us to send it, and where
                                            it is to go and we can automate our part of generating near real time
                                            actionable intelligence responses to identified mission critical events.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6" style="display: flex;justify-content: center;">
                                    <img src="./assets/images/custom-hiddin/layout.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/binary-data.png" alt="gfx">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Phases I & II: Building a Secure
                                            Digital Ecosystem and Integrating Permanent Security Across All Systems</h6>
                                        <p>
                                            <strong>Phase I</strong><br>
                                            The marketplace and communication platform built with our technologies was
                                            designed to secure and record the digital interactions between individuals,
                                            business entities and divisions of government. Other than providing software
                                            development Integration (SDI) kits for business entities and government
                                            divisions to establish the connections between our network and their
                                            proprietary information systems, and establish an all-government buffer
                                            network, our technologies are not deployed within the proprietary systems of
                                            our business and government participants in this first phase.
                                        </p>
                                        <p>
                                            <strong>Phase II</strong><br>
                                            Working through our business entity’s CPAs and our government division’s
                                            accountants to arrange with either our third-party software developers or
                                            their own IT specialists we intend to license our technologies so they can
                                            customize our capabilities to address their organization’s requirements to
                                            keep their secrets safe with our technologies. Building out one entity
                                            within a particular industry should provide a rough security template for
                                            every other entity within that industry and offer a crude version to start
                                            redesigning for several other industry and or government types. The idea is
                                            the more we customize our solutions the more templates we will have to adapt
                                            to other solution types. Overhauling every business entity’s and government
                                            division’s proprietary information system to internalize our permanent
                                            security solutions and to deliver the economic benefits of our secure
                                            technologies and of operating at marketplace scale is the objectives of
                                            phase II.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">All-Government Network: Securing
                                            DOW Data and Departmental Separation</h6>
                                        <p>
                                            The all-government monkey in the middle keesp government departmental
                                            secrets separate from each other and from our private sector data. DOW
                                            secrets need to remain in DOW networks and whatever data DOW type divisions
                                            need to share with each other and any other non-DOW governmental divisions
                                            need to pass through an all-government monkey in the middle and not ever
                                            enter the realm of private sector data.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/connect.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img class="height450" src="./assets/images/custom-hiddin/shield.png" alt="gfx">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Securing the DOW Chain of Command
                                            with Tokenization and Reciprocal Authentication</h6>
                                        <p>
                                            Tokenization, reciprocal authentication, and auto generative symmetric
                                            encryption give us the best chance of securing the DOW chain of command from
                                            the most remote of sensors, warfighters, and autonomous vehicles, drones and
                                            robots on the outermost edge all along the chain of command up to and then
                                            back down from central command and control. Authenticating supply chain
                                            requests and verifying resource deliveries informs central command and
                                            control of what our warfighters need and when they get what they need to
                                            conduct their assigned operations. Deploying a secure network linking every
                                            DOW asset with our technologies would produce data that only the DOW can
                                            make useful while providing near real time actionable intelligence
                                            capabilities for command and control. Delivering this level of
                                            authentication and control to all government divisions is the objective and
                                            requires that we stand up a separate networked version of our technologies
                                            for each government division and an all government only network for
                                            automating government interdepartmental communications.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</ion-content>